// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2SbZr","header":"PatientBlock_header__1J4zF","label":"PatientBlock_label__2JfC5","option":"PatientBlock_option__2gH8B"};